import { useMutation } from "@tanstack/react-query"

import { invalidateSessionMedia } from "../invalidateSessionMedia"
import { trpcOptions } from "../trpc"

export function useReuseClaimPhotoForView(sessionId: string) {
  return useMutation(
    trpcOptions.app.reuseClaimPhotoForView.mutationOptions({ onSuccess: () => invalidateSessionMedia(sessionId) }),
  )
}
